// localStorageHelper.ts

class LocalStorageObject {
  static set<T>(key: string, value: T): void {
    try {
      const json = JSON.stringify(value);
      localStorage.setItem(key, json);
    } catch (err) {
      console.error(`localStorage set error for key "${key}":`, err);
    }
  }

  static get<T>(key: string): T | null {
    try {
      const json = localStorage.getItem(key);
      return json ? (JSON.parse(json) as T) : null;
    } catch (err) {
      console.error(`localStorage get error for key "${key}":`, err);
      return null;
    }
  }

  static remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.error(`localStorage remove error for key "${key}":`, err);
    }
  }

  static clear(): void {
    try {
      localStorage.clear();
    } catch (err) {
      console.error('localStorage clear error:', err);
    }
  }
}

export default LocalStorageObject;
